import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { DataField } from '@eastcoal/formily/exports/core'

export const quotaValue2Validator: SchemaItem['x-validator'] = {
  required: true,
  validator(_, __, ctx) {
    const parentField = ctx.field.parent as DataField
    const { value2, value1 } = parentField.value
    if (isNil(value2)) {
      return '最大值不能为空'
    }

    if (value2 <= 0) {
      return '最大值不能小于等于0'
    }

    if (!isNil(value1) && value1 > value2) {
      return '最大值不能小于最小值'
    }

    return null
  }
}
